"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSolanaAddress = void 0;
const tslib_1 = require("tslib");
const sol_did_client_1 = require("@identity.com/sol-did-client");
const web3_js_1 = require("@solana/web3.js");
const R = tslib_1.__importStar(require("ramda"));
const fetchSNSPublicKeyForDomain_1 = tslib_1.__importDefault(require("./fetchSNSPublicKeyForDomain"));
function isSolanaAddress(address) {
    try {
        // eslint-disable-next-line no-new
        new web3_js_1.PublicKey(address);
        return true;
    }
    catch (error) {
        return false;
    }
}
exports.isSolanaAddress = isSolanaAddress;
const solanaTestNetworks = ["devnet", "testnet"];
const connectionDidPrefix = (options) => {
    var _a;
    const solanaConnection = (_a = options.solana) === null || _a === void 0 ? void 0 : _a.connection;
    if (!solanaConnection) {
        return "";
    }
    const endpoint = solanaConnection.rpcEndpoint;
    const testNetwork = solanaTestNetworks.find((network) => endpoint.includes(network));
    return testNetwork ? `${testNetwork}:` : "";
};
function resolveDid(did, address, options) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const didDocument = yield sol_did_client_1.DidSolService.build(sol_did_client_1.DidSolIdentifier.parse(did), {
            connection: (_a = options.solana) === null || _a === void 0 ? void 0 : _a.connection,
        }).resolve();
        return {
            address,
            document: didDocument,
        };
    });
}
function resolveRequestToDid(query, options) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (R.isEmpty(query)) {
            throw new Error("Invalid query");
        }
        try {
            if (query.match(/^did:/)) {
                // extract the last component of the did as the address
                const address = R.pipe(R.split(":"), R.last)(query);
                return resolveDid(query, address, options);
            }
            if (isSolanaAddress(query)) {
                const did = `did:sol:${connectionDidPrefix(options)}${query}`;
                return resolveDid(did, query, options);
            }
            const publicKeyForSNSDomainHandle = yield (0, fetchSNSPublicKeyForDomain_1.default)(query, (_a = options.solana) === null || _a === void 0 ? void 0 : _a.connection);
            const did = `did:sol:${connectionDidPrefix(options)}${publicKeyForSNSDomainHandle}`;
            return resolveDid(did, publicKeyForSNSDomainHandle, options);
        }
        catch (error) {
            throw new Error(`Unable to resolve [${query}] to did: ${error === null || error === void 0 ? void 0 : error.message}`);
        }
    });
}
exports.default = {
    resolveRequestToDid,
};
